// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"dddc7164","184":"5c3aa9a4","405":"93b82a8e","787":"69cbd938"}[chunkId] + ".chunk.js";
};